import PropTypes from "prop-types";
import classNames from "classnames";
import "./ButtonGroup.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ButtonGroup = ({ options, value, onChange }) => (
	<div className="button-group">
		{options.map(option => (
			<button
				key={option.value}
				type="button"
				className={classNames("button-group__item", {
					"button-group__item--active": option.value === value,
				})}
				onClick={() => onChange(option.value)}
			>
				<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold>
					{option.label}
				</Typography>
			</button>
		))}
	</div>
);

ButtonGroup.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ButtonGroup;
